module.exports = __webpack_public_path__ + "static/media/fatcat3.3d56bccf.png";